import { render, staticRenderFns } from "./AggregatorsStatusWidget.vue?vue&type=template&id=1b321394&scoped=true&"
import script from "./AggregatorsStatusWidget.vue?vue&type=script&lang=js&"
export * from "./AggregatorsStatusWidget.vue?vue&type=script&lang=js&"
import style0 from "./AggregatorsStatusWidget.vue?vue&type=style&index=0&id=1b321394&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b321394",
  null
  
)

export default component.exports